import { Injectable } from '@angular/core';
import { UrlHelper } from "../../classes/urlHelper";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrademarkService {
  constructor(private httpClient: HttpClient) {
  }

  queryTrademarks(query: any) {
    return this.httpClient.get<any>('api/Trademark/Query' + new UrlHelper().parseToUrlParams(query, 'query.'));
  }

  getTrademark(id: string) {
    return this.httpClient.get<any>('api/Trademark/GetTrademark?id=' + encodeURIComponent(id));
  }

  saveTrademark(trademark: any) {
    return this.httpClient.post<any>('api/Trademark/SaveTrademark', trademark);
  }

  deleteTrademark(id: string) {
    return this.httpClient.post<any>('api/Trademark/DeleteTrademark', { Id: id });
  }

  checkTrademark(productName: string) {
    return this.httpClient.get<any>('api/Trademark/CheckTrademark?productName=' + encodeURIComponent(productName));
  }

  checkTrademarksInName(productName: string) {
    return this.httpClient.get<any>('api/Trademark/CheckTrademarksInName?productName=' + encodeURIComponent(productName));
  }
}

